import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { useState } from "react";
import data from "./data";
import Board from "./components/Board";
import { useTheme } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "auto",
    height: "100%",

    "& .section": {
      display: "flex",
      flexFlow: "row",
      justifyContent: "flex-start",
      alignItems: "stretch",
      userSelect: "none",
      minWidth: "fit-content",
      height: "100%",
      gap: "0px",
    },
    "& .wrapper": {
      display: "flex",
      gap: "0px",

      "& .box": {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignSelf: "auto",
        flex: "1 1 auto",
        minWidth: "282px",
        maxWidth: "282px",

        "& .box-wrap": {
          borderRadius: "6px",
          display: "flex",
          flexDirection: "column",
          alignSelf: "auto",
          flex: "1 1 auto",
          marginLeft: "8px",
          marginRight: "8px",
          backgroundColor: theme.palette.background.paper,
        },
      },
    },
    "& .c-header": {
      "& small": {
        backgroundColor: theme.palette.action.selected,
        borderRadius: "8px",
        fontSize: "10px",
        padding: "3px 8px",
        marginLeft: "5px",
      },
    },
    "& .cat-label": {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.common.white,
      borderRadius: "8px",
      fontSize: "10px",
      padding: "3px 8px",
    },
  },
}));

export default function GridView(props) {
  const theme = useTheme();
  const classes = useStyles(props);
  const [dummyData, setDummyDate] = useState(data);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleViewDetail = () => {
    setOpen(true);
  };

  return (
    <>
      <Board />
      {/* <Box className={clsx(classes.root)}>
        <Box className="section">
          <div className="wrapper">
            <Box className="box">
              <div className="box-wrap">
                <Box className="c-header" sx={{ p: 2 }}>
                  <Typography>
                    New <small>50</small>
                  </Typography>
                </Box>
                <Box className="card-list" sx={{ px: 2 }}>
                  {dummyData.map((d) => (
                    <>
                      <Card
                        onClick={handleViewDetail}
                        sx={{ background: theme.palette.background.paper, mb: 1.5 }}
                      >
                        <CardContent sx={{ p: "16px !important" }}>
                          <Typography
                            sx={{ fontSize: 12 }}
                            variant="h5"
                            component="div"
                          >
                            {d.commissionName}
                          </Typography>
                          <Typography
                            sx={{ fontSize: 10 }}
                            color="text.secondary"
                            gutterBottom
                          >
                            {d.created}
                          </Typography>
                          <Typography
                            sx={{ fontSize: 11, mt: 1.2, mb: 2 }}
                            component="div"
                          >
                            <small className="cat-label">{d.category}</small>{" "}
                            {d.product}
                          </Typography>
                          <Divider sx={{ my: 1 }} />
                          <Box className="flex">
                            <Box className="flex" sx={{ pt: 0.5 }}>
                              <FuseSvgIcon size={16} color={theme.palette.info.main}>
                                heroicons-solid:check-circle
                              </FuseSvgIcon>{" "}
                              <Typography
                                sx={{ fontSize: 11, pl: 0.5 }}
                                component="span"
                              >
                                {d.orderNo}
                              </Typography>
                            </Box>
                            <Box
                              className="flex justify-end"
                              sx={{ flexGrow: 1 }}
                            >
                              <IconButton size="small">
                                <FuseSvgIcon size={16}>
                                  heroicons-solid:chat-alt-2
                                </FuseSvgIcon>
                              </IconButton>
                              <IconButton size="small">
                                <FuseSvgIcon size={16}>
                                  heroicons-solid:user-circle
                                </FuseSvgIcon>
                              </IconButton>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </>
                  ))}
                </Box>
              </div>
            </Box>
            <Box className="box">
              <div className="box-wrap">
                <Box className="c-header" sx={{ p: 2 }}>
                  <Typography>
                    In Progress <small>50</small>
                  </Typography>
                </Box>
                <Box className="card-list" sx={{ px: 2 }}>
                  asd
                </Box>
              </div>
            </Box>
            <Box className="box">
              <div className="box-wrap">
                <Box className="c-header" sx={{ p: 2 }}>
                  <Typography>
                    In Progress <small>50</small>
                  </Typography>
                </Box>
                <Box className="card-list" sx={{ px: 2 }}>
                  asd
                </Box>
              </div>
            </Box>
            <Box className="box">
              <div className="box-wrap">
                <Box className="c-header" sx={{ p: 2 }}>
                  <Typography>
                    In Progress <small>50</small>
                  </Typography>
                </Box>
                <Box className="card-list" sx={{ px: 2 }}>
                  asd
                </Box>
              </div>
            </Box>
            <Box className="box">
              <div className="box-wrap">
                <Box className="c-header" sx={{ p: 2 }}>
                  <Typography>
                    In Progress <small>50</small>
                  </Typography>
                </Box>
                <Box className="card-list" sx={{ px: 2 }}>
                  asd
                </Box>
              </div>
            </Box>
          </div>
        </Box>
      </Box>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          sasdasdds
        </DialogContent>
      </Dialog> */}
    </>
  );
}
